export const CLASSE_BALAO_EM_ALERTA = 'maino-tour-popover-alerta'
export const TITULO_ALERTA_ENVIO = 'Não foi possível prosseguir'
export const TEXTO_ALERTA_ENVIO = 'Há erros no formulário. Clique em Voltar, corrija e prossiga novamente.'

const SELETOR_BOTAO_DE_ENVIO = '[type="submit"]'
const SELETOR_MODAL = '.modal'
const SELETOR_ERRO_DE_ENVIO = '.panel-danger, .has-error, .is-invalid'
const CLASSE_TITULO_EM_ALERTA = 'text-error-40'
const CLASSE_EXIBIR = 'd-block'
const CLASSE_OCULTAR = 'd-none'

export function modalDoAlvo(alvo) {
  return alvo?.closest?.(SELETOR_MODAL) || null
}

export function ehBotaoDeEnvio(alvo) {
  return Boolean(alvo?.matches?.(SELETOR_BOTAO_DE_ENVIO))
}

export function ehPassoDeEnvio(alvo) {
  if (!ehBotaoDeEnvio(alvo)) return false
  return Boolean(modalDoAlvo(alvo))
}

export function camposBarradosPeloNavegador(alvo) {
  const formulario = alvo?.form
  if (!formulario || formulario.noValidate || alvo.formNoValidate) return []
  return Array.from(formulario.elements).filter((campo) => campo.willValidate && !campo.validity.valid)
}

export function errosDeEnvio(alvo) {
  const errosNaTela = Array.from(modalDoAlvo(alvo)?.querySelectorAll(SELETOR_ERRO_DE_ENVIO) || [])
  return [...errosNaTela, ...camposBarradosPeloNavegador(alvo)]
}

export function envioFalhou(alvo) {
  return errosDeEnvio(alvo).length > 0
}

export function aplicarAlertaDeEnvio(popover) {
  if (!popover) return
  popover.wrapper.classList.add(CLASSE_BALAO_EM_ALERTA)
  popover.title.textContent = TITULO_ALERTA_ENVIO
  popover.description.textContent = TEXTO_ALERTA_ENVIO
  popover.title.classList.add(CLASSE_EXIBIR, CLASSE_TITULO_EM_ALERTA)
  popover.description.classList.add(CLASSE_EXIBIR)
  popover.nextButton.classList.add(CLASSE_OCULTAR)
}
